import { Link } from 'react-router-dom'

import { useWindowShell } from '@krp/client-runtime'
import { ActionInfo, StatusMessage } from '@krp/ui-kit'

import { MenuIcon } from './MenuIcon'

/** Главная: разделы из реестра окон — тот же список, что в меню, по группам. */
export function HomePage() {
  const shell = useWindowShell()
  const groups = [
    { id: 'work', title: 'Работа', items: shell.menu('work') },
    { id: 'settings', title: 'Настройки', items: shell.menu('settings') },
  ].filter((group) => group.items.length > 0)
  return (
    <section aria-labelledby="home-title" className="shell-home">
      <h2 id="home-title">Разделы</h2>
      {groups.length === 0 ? (
        <StatusMessage kind="empty" title="Разделов пока нет" />
      ) : (
        groups.map((group) => (
          <div key={group.id} className="shell-home__group">
            <h3 className="shell-home__heading">{group.title}</h3>
            <ul className="shell-home__list">
              {group.items.map((item) => (
                <li key={item.kind}>
                  <ActionInfo id="shell.home-link" label={item.label} layout="block">
                    <Link to={item.path} className="shell-home__item">
                      <MenuIcon name={item.icon} size={20} />
                      <span>{item.label}</span>
                    </Link>
                  </ActionInfo>
                </li>
              ))}
            </ul>
          </div>
        ))
      )}
    </section>
  )
}

/** Адрес не обслуживается ни одним окном: 404 клиента, без падения оболочки. */
export function NotFoundPage() {
  return (
    <StatusMessage
      kind="empty"
      title="Такого окна нет"
      text="Адрес не обслуживается ни одним разделом."
      action={
        <ActionInfo id="shell.not-found-home">
          <Link to="/">На главную</Link>
        </ActionInfo>
      }
    />
  )
}
